module.exports = __webpack_public_path__ + "img/glass.965175d5.png";